"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StabilityDeposit = void 0;
const Decimal_1 = require("./Decimal");
/**
 * A Stability Deposit and its accrued gains.
 *
 * @public
 */
class StabilityDeposit {
    /**
     * Address of frontend through which this Stability Deposit was made.
     *
     * @remarks
     * If the Stability Deposit was made through a frontend that doesn't tag deposits, this will be
     * the zero-address.
     */
    /** @internal */
    constructor(initialSTAR, currentSTAR, collateralGain, preonReward) {
        this.initialSTAR = initialSTAR;
        this.currentSTAR = currentSTAR;
        this.collateralGain = collateralGain;
        this.preonReward = preonReward;
        if (this.currentSTAR.gt(this.initialSTAR)) {
            throw new Error("currentSTAR can't be greater than initialSTAR");
        }
    }
    get isEmpty() {
        return (this.initialSTAR.isZero &&
            this.currentSTAR.isZero &&
            this.collateralGain.isZero &&
            this.preonReward.isZero);
    }
    /** @internal */
    toString() {
        return (`{ initialSTAR: ${this.initialSTAR}` +
            `, currentSTAR: ${this.currentSTAR}` +
            `, collateralGain: ${this.collateralGain}` +
            `, preonReward: ${this.preonReward}`);
    }
    /**
     * Compare to another instance of `StabilityDeposit`.
     */
    equals(that) {
        return (this.initialSTAR.eq(that.initialSTAR) &&
            this.currentSTAR.eq(that.currentSTAR) &&
            JSON.stringify(this.collateralGain) == JSON.stringify(that.collateralGain) &&
            this.preonReward.eq(that.preonReward));
    }
    /**
     * Calculate the difference between the `currentSTAR` in this Stability Deposit and `thatSTAR`.
     *
     * @returns An object representing the change, or `undefined` if the deposited amounts are equal.
     */
    whatChanged(thatSTAR) {
        thatSTAR = Decimal_1.Decimal.from(thatSTAR);
        if (thatSTAR.lt(this.currentSTAR)) {
            return { withdrawSTAR: this.currentSTAR.sub(thatSTAR), withdrawAllSTAR: thatSTAR.isZero };
        }
        if (thatSTAR.gt(this.currentSTAR)) {
            return { depositSTAR: thatSTAR.sub(this.currentSTAR) };
        }
    }
    /**
     * Apply a {@link StabilityDepositChange} to this Stability Deposit.
     *
     * @returns The new deposited STAR amount.
     */
    apply(change) {
        if (!change) {
            return this.currentSTAR;
        }
        if (change.withdrawSTAR !== undefined) {
            return change.withdrawAllSTAR || this.currentSTAR.lte(change.withdrawSTAR)
                ? Decimal_1.Decimal.ZERO
                : this.currentSTAR.sub(change.withdrawSTAR);
        }
        else {
            return this.currentSTAR.add(change.depositSTAR);
        }
    }
}
exports.StabilityDeposit = StabilityDeposit;
//# sourceMappingURL=StabilityDeposit.js.map